import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, Button } from 'ui/button';
import { Modal, ModalFooter, ModalHeader, ModalBody, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { addPositiveToast } from 'modules/toastContainer';
import { cloneEdges, cloneNodes, closeModal } from '../../ducks';
import { CLONE_NODE_MODAL } from '../../constants';
import { parseAddedEdges, parseClonedNodes } from '../../utils';
import { Edge, Node } from '../../types';
import {
  ChartEntity,
  NodeAction,
  createContentFor,
  generateToastText,
  generateBody,
  generateTitle,
} from './utils';

export type CloneNodeModalProps = {
  /**  Edges to clone */
  edgesToClone: Edge[];
  /**  Nodes to clone */
  nodesToClone: Node[];
  /** Whether the modal is open */
  isOpen: boolean;
};

export const CLONE_ACTION_ID = 'clone-nodes';

export const CloneNodeModal = ({
  edgesToClone = [],
  nodesToClone = [],
  isOpen,
}: CloneNodeModalProps) => {
  const dispatch = useDispatch();
  const handleCloseModal = () => dispatch(closeModal(CLONE_NODE_MODAL));

  const handleSubmit = () => {
    dispatch(cloneNodes(parseClonedNodes(nodesToClone)));
    dispatch(cloneEdges(parseAddedEdges(edgesToClone)));

    dispatch(addPositiveToast(generateToastText(NodeAction.Clone, ChartEntity.NODE, nodesToClone)));
    handleCloseModal();
  };

  return (
    <Modal
      id={CLONE_NODE_MODAL}
      isModalOpen={isOpen}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>
        {createContentFor(generateTitle, nodesToClone, ChartEntity.NODE, NodeAction.Clone)}?
      </ModalHeader>
      <ModalBody>
        {createContentFor(generateBody, nodesToClone, ChartEntity.NODE, NodeAction.Clone)}
      </ModalBody>
      <ModalFooter>
        <Button
          autoFocus
          data-test={CLONE_ACTION_ID}
          onClick={handleSubmit}
          size={BUTTON_SIZES.LARGE}
        >
          {createContentFor(generateTitle, nodesToClone, ChartEntity.NODE, NodeAction.Clone)}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
